import React from 'react';
import VideoPlayer from 'components/ai/tools/VideoPlayer';
import AudioButton from 'components/AudioButton';
import styled from 'styled-components';

import MessageParts from '../CharacterMessageSwitcher/components/CharacterMessage/components/MessageParts';
const NarratorMessage = (props) => {
  const { message = {}, onZoomClick = () => { }, setVideoModalState = () => { }, topRightComponent = null } = props;
  const { content = {}, extra = {} } = message;
  const { parts = [], type } = content;
  const videoWithSound = extra?.videoWithSound;

  return (
    <div className="assistant_message_placeholder narrator_message_placeholder mt-4 mb-4">
      <div className="flex flex-col justify-center">
        {type === 'text' && (
          <NarratorPartPlaceholder><MessageParts parts={parts} isNarrator /> </NarratorPartPlaceholder>
        )}
        {extra?.imageUrl && (
          <div className="relative mx-auto mt-6">
            {!extra.videoUrl ? (
              <>
                <NarratorImage src={extra.imageUrl} alt="narrator image" />
                <ZoomPictureButton onClick={() => onZoomClick(extra.imageUrl)} />
              </>
            ) : (
              <>
                <VideoWrapper>
                  <VideoPlayer
                    size="100%"
                    imageUrl={extra.imageUrl}
                    videoUrl={extra.videoUrl}
                    setVideoModalState={setVideoModalState}
                  />
                </VideoWrapper>
                {videoWithSound && (
                  <AudioButtonContainer>
                    <AudioButton />
                  </AudioButtonContainer>
                )}
              </>
            )}
          </div>
        )}
        {topRightComponent && <>{topRightComponent}</>}
      </div>
    </div>
  );
};

export default NarratorMessage;

const NarratorPartPlaceholder = styled.div`
  max-width: 476px;
  border-radius: 8px 4px 8px 8px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
  color: rgba(169, 169, 169, 1);
  text-align: left;
  font-style: italic;
`;

const VideoWrapper = styled.div`
  width: calc(min(75vh, 75vw, 320px));
  height: calc(min(75vh, 75vw, 320px));
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  display: flex;
  flex-direction: column;
`;

const NarratorImage = styled.img`
  border-radius: 12px;
  max-width: 320px;
  max-height: 320px;
  width: 100%;
  height: 100%;
`;

const AudioButtonContainer = styled.div`
  padding-top: 12px;
  margin-bottom: -12px;
  padding-left: 6px;
`;

const ZoomPictureButton = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: calc(min(75vh, 75vw, 320px));
  height: calc(min(75vh, 75vw, 320px));
  border-radius: 12px;
  cursor: pointer;
`;

